
// Landing page stuff

jQuery(document).ready(function ($) {


    // Reset landing page
    $('[data-action="reset-landing"]').on('click',function(){
        localStorage.removeItem('state');
        location.reload();
    });

    // Landing page state selection
    // This was used to close the modal on "other" state -- removing bc now it's a link to a page
    // $('.state-selection').on('click', 'a', function (e) {
    //     var parent = $(e.currentTarget).parent();
    //     if (parent.hasClass('state-other')) {
    //         e.preventDefault();
    //         $('#state-select-modal').foundation('close');
    //     }
    // });

    // Expand additional state list on state select modal
    $('#state-select-modal [data-action=expand-list]').on('click',function(){
        $(this).hide();
        const fullStateList = $(this).next('.state-list');
        $(this).prev('.state-list').slideUp(400, function() {
            fullStateList.slideDown();
         });

    });

    // Hide state select dropdown if state select modal is open
    $('#state-select-modal').on('open.zf.reveal',function(){
        $('.change-state').addClass('hide');
        $('.hide-on-modal').addClass('hidden');
    });

    // If state select modal is closed, show all landing page elements
    $('#state-select-modal').on('closed.zf.reveal',function(){
        console.log('closing up');
        $('.change-state').removeClass('hide');
        $('.hide-on-modal').removeClass('hidden');
    });






    // Trigger announcement modal
    /*
    if ( $('.landing-page').length && localStorage.getItem('announcement-read') != 1 ) {
        $('#announcement-modal').foundation('open');
        $('.hide-on-modal').addClass('hidden');
    }

    // Close announcement modal 
    $('#announcement-modal').on('closed.zf.reveal',function(){
        localStorage.setItem('announcement-read', 1);
        $('#state-select-modal').foundation('open');
    });
    */


    //Trigger state select modal
    //If on landing page and state is not other || #state present in URL
    /*
    if ( $('.landing-page').length && localStorage.getItem('announcement-read') == 1 || window.location.hash == '#state') {
        console.log('fire modal!');
        $('#state-select-modal').foundation('open');
    }
    */

    if (localStorage.getItem('state') == "other") {
        $('.change-state').removeClass('hide');
    }


    // VLL landing page
    if ($('.page-template-page-landing-vll').length ) {
        $('#district-select-modal').foundation('open');
    }

    $('.district-selection').on('click', 'a', function(e){
        e.preventDefault();
        var district = $(this).data('select');
        localStorage.setItem('vll-district', district);
        $('#district-select-modal').foundation('close');
        window.location.href = 'https://www.algebranation.com/vll/courses/algebra-nation-virtual-learning-lab/';
    });


    // VLL conditional video

    // No leaderboard on Palm Beach
    if(localStorage.getItem('vll-district') == 'palm-beach') {
        $('.teacher-area-no-leaderboard').show();
        $('.teacher-area-leaderboard').hide();
    } else {
        $('.teacher-area-no-leaderboard').hide();
        $('.teacher-area-leaderboard').show();
    }



    
});